import s from './tabPanel.module.scss';
import { FC, ReactNode } from 'react';

type Props = {
  children: ReactNode;
  ariaHidden?: boolean;
};

const TabPanel: FC<Props> = ({ children, ariaHidden }) => {
  return (
    <div
      className={s.host}
      aria-hidden={ariaHidden}
      role="tabpanel"
      aria-labelledby={`content-tab`}
    >
      {!ariaHidden && children}
    </div>
  );
};

export default TabPanel;
